import { verifiers, selectors } from '@yola/subscription-manager-js';
import store from 'src/js/store';

function isDomainExtraPriceAvailable(isFreeDomainFlagEnabled) {
  const state = store.getState();

  const activeSubscriptions = selectors.getActiveSubscriptions(state);
  const subscriptionsList = selectors.getSubscriptionList(state);

  if (!subscriptionsList || !activeSubscriptions) return false;

  const hasEverHadDomainSubscription = subscriptionsList.some(({ type }) =>
    verifiers.isDomainPackageType(type)
  );

  if (hasEverHadDomainSubscription || !isFreeDomainFlagEnabled) {
    return false;
  }

  return true;
}

export default isDomainExtraPriceAvailable;
